/**
 * <s-tab-title> swaps the browser tab title for friendly "come back" messages
 * while the shopper is on another tab, rotating through them every few seconds,
 * and restores the page's own title as soon as they return.
 *
 * Messages come from data-messages (a "|"-separated, translated list written by Liquid).
 */
class TabTitleElement extends HTMLElement {
  connectedCallback() {
    this.messages = (this.dataset.messages || '').split('|').map((m) => m.trim()).filter(Boolean);
    if (!this.messages.length) return;

    this.originalTitle = document.title;
    this.index = 0;
    this.timer = null;
    this.onVisibility = () => (document.hidden ? this.#away() : this.#back());
    document.addEventListener('visibilitychange', this.onVisibility);
  }

  disconnectedCallback() {
    document.removeEventListener('visibilitychange', this.onVisibility);
    this.#back();
  }

  #away() {
    this.originalTitle = document.title;
    this.index = 0;
    document.title = this.messages[0];
    clearInterval(this.timer);
    this.timer = setInterval(() => {
      this.index = (this.index + 1) % this.messages.length;
      document.title = this.messages[this.index];
    }, 3000);
  }

  #back() {
    clearInterval(this.timer);
    this.timer = null;
    if (this.originalTitle) document.title = this.originalTitle;
  }
}

if (!customElements.get('s-tab-title')) {
  customElements.define('s-tab-title', TabTitleElement);
}
